import { Input, OnInit } from '@angular/core';
import { ControlValueAccessor, FormControl } from '@angular/forms';

export abstract class VrElementField implements ControlValueAccessor, OnInit {
  @Input() id = this.getId();
  @Input() classeCss: any;
  @Input() name = '';
  @Input() isReadOnly = false;
  @Input() isDisabled = false;
  @Input() isRequired = false;
  @Input() control!: FormControl;

  isError = false;

  protected innerValue: any;

  @Input() set value(v: any) {
    if (v !== this.innerValue) {
      this.innerValue = v;
      this.elementChange(v);
      this.onChange(v);
    }
  }

  get value(): any {
    return this.innerValue;
  }

  ngOnInit(): void {
    this.setRequiredState();
  }

  protected onChange: any = (_: any) => {
    /*Empty*/
  }
  protected onTouched: any = () => {
    /*Empty*/
  }
  protected elementChange(v: any): void {
    /*Empty*/
  }

  writeValue(v: any): void {
    this.value = v;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  setRequiredState(): void {
    if (this.control) {
      const hasErrors = this.control?.errors ?? false;
      if (hasErrors) {
        this.isRequired = hasErrors?.required ?? false;
      }
    }
  }

  onBlur(): void {
    this.onTouched();
  }

  onSelectChange(value: any): void {
    this.onChange(value);
  }

  private getId(): string {
    return Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 9) + Date.now().toString();
  }
}
